import React from "react"
import { select } from "d3-selection"

export default function GraphInputField({
  update_field,
  field_value,
  field_label,
  field,
  warning_label,
  disabled,
}) {
  return (
    <div className={"row"} style={{ marginBottom: "15px" }}>
      <div className={"col-4"}>
        <b>
          <label>{`${field_label}${!disabled ? "*" : ""}:`}</label>
        </b>
      </div>
      <div className={"col-8"}>
        <span
          id={`${field}_err_message`}
          className={"requiredFieldWarning required-message"}
          style={{ display: "None" }}
        >
          {warning_label}
        </span>
        {!disabled ? (
          <input
            value={field_value}
            style={{ width: "100%" }}
            disabled={disabled}
            onChange={(ev) => {
              select(`#${field}_err_message`).style("display", "none")
              update_field(ev.target.value)
            }}
          />
        ) : (
          <span>{field_value}</span>
        )}
      </div>
    </div>
  )
}
